import UserService from '@/services/user'

export default {
	getBalance({commit}, num) {
		commit('SET_BALANCE', num)
		return Promise.resolve(num)
	},
	setPin({commit}, pin) {
		commit('SET_PIN', pin)
		return Promise.resolve(pin)
	},
	createPin({commit}, payload) {
		return new Promise((resolve, reject) => {
			UserService.createPin(payload, {
				headers: {
		          'Authorization': localStorage.token
		        }
			})
			.then(response => {
				commit('SET_USER_PIN', payload.pin)
				resolve()
			})
			.catch(e => reject(e))
		})
	},
	changePin({commit}, payload) {
		return new Promise((resolve, reject) => {
			UserService.changePin(payload, {
				headers: {
		          'Authorization': localStorage.token
		        }
			})
			.then(response => {
				commit('SET_USER_PIN', payload.pin)
				resolve()
			})
			.catch(e => reject(e))
		})
	}
}